// extracted by mini-css-extract-plugin
module.exports = {"media-object":"media-object_media-object__cBcWc","image-wrapper":"media-object_image-wrapper__NqLWl","media-object-title":"media-object_media-object-title__g_kJ8"};